import styled from 'styled-components';
import Block from '@shared/components/ui/Block';

/**
 * Styles
 */
export const Distribute = styled(Block)<{
    $vAlign?: 'top' | 'bottom' | 'center';
    gap?: number;
}>`
    display: flex;
    justify-content: space-between;
    align-items: ${({ $vAlign }) =>
        $vAlign === 'top'
            ? 'flex-start'
            : $vAlign === 'bottom'
            ? 'flex-end'
            : 'center'};
    gap: ${({ gap }) => gap || 0}px;
`;
